import jwt_decode from 'jwt-decode'
import store from '@/store'

const removeDataTableStates = () => Object.keys(sessionStorage)
                                        .filter(k => /^dt-state/.test(k))
                                        .forEach(k => sessionStorage.removeItem(k))

export default [
    {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "" */ '../views/Index.vue'),
        children: [
            {
                path: '',
                name: 'index',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../components/Public/Index.vue')
            },
            {
                path: 'inscripciones',
                name: 'inscriptions',
                component: () => import(/* webpackChunkName: "Inscriptions" */ '../views/Public/inscriptions.vue')
            },
            {
                path: 'registro-alumno',
                name: 'register-student',
                component: () => import(/* webpackChunkName: "RegisterStudent" */ '../views/Public/CodeStudent.vue')
            },
            {
                path: 'registro-alumno-formulario/:idCoordinator',
                name: 'register-student-form',
                component: () => import(/* webpackChunkName: "RegisterStudentForm" */ '../views/Public/FormStudent.vue')
            },
            {
                path: 'registro-voluntario',
                name: 'register-volunteer',
                component: () => import(/* webpackChunkName: "RegisterVolunteer" */ '../views/Public/CodeVolunteer.vue')
            },
            {
                path: 'registro-voluntario-formulario/:companyCode/:online',
                name: 'register-volunteer-form',
                component: () => import(/* webpackChunkName: "RegisterVolunteerForm" */ '../views/Public/FormVolunteer.vue')
            },
            {
                path: 'registro-coordinador-centro',
                name: 'register-center-coordinator',
                component: () => import(/* webpackChunkName: "RegisterCenterCoordinator" */ '../views/Public/CodeCenterCoordinator.vue')
            },
            {
                path: 'registro-coordinador-centro-formulario/:centerCode',
                name: 'register-center-coordinator-form',
                component: () => import(/* webpackChunkName: "RegisterCenterCoordinatorForm" */ '../views/Public/FormCenterCoordinator.vue')
            },
            {
                path: 'registro-coordinador-empresa',
                name: 'register-company-coordinator',
                component: () => import(/* webpackChunkName: "RegisterCompanyCoordinator" */ '../views/Public/CodeCompanyCoordinator.vue')
            },
            {
                path: 'registro-coordinador-empresa-formulario/:companyCode',
                name: 'register-company-coordinator-form',
                component: () => import(/* webpackChunkName: "RegisterCompanyCoordinatorForm" */ '../views/Public/FormCompanyCoordinator.vue')
            },
            {
                path: 'registro-centro',
                name: 'register-center',
                component: () => import(/* webpackChunkName: "RegisterCenter" */ '../views/Public/CodeCenter.vue')
            },
            {
                path: 'registro-centro-formulario/:programEdition',
                name: 'register-center-form',
                component: () => import(/* webpackChunkName: "RegisterCenterForm" */ '../views/Public/FormCenter.vue')
            },
            {
                path: 'registro-empresa',
                name: 'register-company',
                component: () => import(/* webpackChunkName: "RegisterCompany" */ '../views/Public/CodeCompany.vue')
            },
            {
                path: 'registro-empresa-formulario/:programEdition/:idCoordinator?',
                name: 'register-company-form',
                component: () => import(/* webpackChunkName: "RegisterCompanyForm" */ '../views/Public/FormCompany.vue')
            },
            {
                path: 'gracias',
                name: 'thanks',
                component: () => import(/* webpackChunkName: "Thanks" */ '../views/Public/Thanks.vue')
            },
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
            },
            {
                path: 'olvido-contrasena',
                name: 'forgot-password',
                component: () => import(/* webpackChunkName: "Login" */ '../views/ForgotPassword.vue')
            },
            {
                path: 'resetear-contrasena/:id_user/:token_reset',
                name: 'reset-password',
                component: () => import(/* webpackChunkName: "Login" */ '../views/ResetPassword.vue')
            }
        ]
    },
    {
        path: '/home',
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
        beforeEnter: async (to, from, next) => {
            try {
                jwt_decode(store.state.auth.token);
                return next()
            } catch(e) {
                store.commit('auth/logout', null, { root: true })
                return next('/login')
            }
        },
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
            },
            {
                path: '/centros',
                name: 'centers',
                component: () => import(/* webpackChunkName: "Centers" */ '../views/Private/Centers/Centers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'center') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin", "center_coordinator"] }
            },
            {
                path: '/centros/:id',
                name: 'center',
                component: () => import(/* webpackChunkName: "Center" */ '../views/Private/Centers/Center.vue'),
                meta: { authorize: ["admin", "center_coordinator"] }
            },

            {
                path: '/alumnos',
                name: 'students',
                component: () => import(/* webpackChunkName: "Students" */ '../views/Private/Students/Students.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'student') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/alumnos-sin-validar/:id?',
                name: 'students-no-validate',
                component: () => import(/* webpackChunkName: "StudentsNoValidate" */ '../views/Private/Students/StudentsNoValidate.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/alumnos/:id/:center?',
                name: 'student',
                component: () => import(/* webpackChunkName: "Student" */ '../views/Private/Students/Student.vue'),
                meta: { authorize: ["admin", "student", "center_coordinator"] }
            },

            {
                path: '/empresas',
                name: 'companies',
                component: () => import(/* webpackChunkName: "Companies" */ '../views/Private/Companies/Companies.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'company') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin", "company_coordinator"] }
            },
            {
                path: '/empresas/:id',
                name: 'company',
                component: () => import(/* webpackChunkName: "Company" */ '../views/Private/Companies/Company.vue'),
                meta: { authorize: ["admin", "company_coordinator"] }
            },
            {
                path: '/voluntarios',
                name: 'volunteers',
                component: () => import(/* webpackChunkName: "Volunteers" */ '../views/Private/Volunteers/Volunteers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'voluntary') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/voluntarios/:id/:company?',
                name: 'volunteer',
                component: () => import(/* webpackChunkName: "Volunteer" */ '../views/Private/Volunteers/Volunteer.vue'),
                meta: { authorize: ["admin", "volunteer", "company_coordinator"] }
            },
            {
                path: '/matchings',
                name: 'matchings',
                component: () => import(/* webpackChunkName: "Matchings" */ '../views/Private/Matchings/Matchings.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'matching') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/matchings/:id',
                name: 'matching',
                component: () => import(/* webpackChunkName: "Matching" */ '../views/Private/Matchings/Matching.vue'),
                meta: { authorize: ["admin", "student", "volunteer", "center_coordinator", "company_coordinator"] }
            },
            {
                path: '/buscar-matchings',
                name: 'searchMatchings',
                component: () => import(/* webpackChunkName: "SearchMatchings" */ '../views/Private/Matchings/SearchMatchings.vue'),
                meta: { authorize: ["volunteer"] }
            },
            {
                path: '/notificaciones',
                name: 'notifications',
                component: () => import(/* webpackChunkName: "Notifications" */ '../views/Private/Notifications/Notifications.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'notification') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/notificaciones/:id',
                name: 'notification',
                component: () => import(/* webpackChunkName: "Notification" */ '../views/Private/Notifications/Notification.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/coordinadores-empresa/:id/:company?',
                name: 'companyCoordinators',
                component: () => import(/* webpackChunkName: "CompanyCoordinators" */ '../views/Private/CompanyCoordinators/CompanyCoordinator.vue'),
                meta: { authorize: ["admin", "company_coordinator"] }
            },
            {
                path: '/coordinadores-centro/:id/:center?',
                name: 'centerCoordinators',
                component: () => import(/* webpackChunkName: "CenterCoordinators" */ '../views/Private/CenterCoordinators/CenterCoordinator.vue'),
                meta: { authorize: ["admin", "center_coordinator"] }
            },
            {
                path: '/tipo-centros',
                name: 'typeCenters',
                component: () => import(/* webpackChunkName: "TypeCenters" */ '../views/Private/TypeCenters/TypeCenters.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'typeCenter') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tipo-centros/:id',
                name: 'typeCenter',
                component: () => import(/* webpackChunkName: "TypeCenter" */ '../views/Private/TypeCenters/TypeCenter.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/cursos',
                name: 'courses',
                component: () => import(/* webpackChunkName: "Courses" */ '../views/Private/Courses/Courses.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'course') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/cursos/:id',
                name: 'course',
                component: () => import(/* webpackChunkName: "Course" */ '../views/Private/Courses/Course.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/areas-trabajo',
                name: 'areasJob',
                component: () => import(/* webpackChunkName: "AreasJob" */ '../views/Private/AreasJob/AreasJob.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'areaJob') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/areas-trabajo/:id',
                name: 'areaJob',
                component: () => import(/* webpackChunkName: "AreaJob" */ '../views/Private/AreasJob/AreaJob.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/nivel-lenguajes',
                name: 'levelLanguages',
                component: () => import(/* webpackChunkName: "LevelLanguages" */ '../views/Private/LevelLanguages/LevelLanguages.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'levelLanguage') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/nivel-lenguajes/:id',
                name: 'levelLanguage',
                component: () => import(/* webpackChunkName: "LevelLanguage" */ '../views/Private/LevelLanguages/LevelLanguage.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/fechas-alumno',
                name: 'datesStudent',
                component: () => import(/* webpackChunkName: "DatesStudent" */ '../views/Private/DatesStudent/DatesStudent.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'dateStudent') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/fechas-alumno/:id',
                name: 'dateStudent',
                component: () => import(/* webpackChunkName: "DateStudent" */ '../views/Private/DatesStudent/DateStudent.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/usuarios',
                name: 'users',
                component: () => import(/* webpackChunkName: "Users" */ '../views/Private/Users/Users.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'user') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/usuarios/:id',
                name: 'user',
                component: () => import(/* webpackChunkName: "User" */ '../views/Private/Users/User.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/socios',
                name: 'partners',
                component: () => import(/* webpackChunkName: "Partners" */ '../views/Private/Partners/Partners.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/patrocinadores',
                name: 'sponsors',
                component: () => import(/* webpackChunkName: "Sponsors" */ '../views/Private/Sponsors/Sponsors.vue'),
                meta: { authorize: ["admin"] }
            },            
            {
                path: '/configuracion',
                name: 'configuration',
                component: () => import(/* webpackChunkName: "Configuration" */ '../views/Private/Configuration/Configuration.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/mis-alumnos',
                name: 'myStudents',
                component: () => import(/* webpackChunkName: "myStudents" */ '../views/Private/Students/MyStudents.vue'),
                meta: { authorize: ["admin", "center_coordinator"] }
            }
        ]
    },
    { path: "/:pathMatch(.*)*", redirect: '/' }
]